import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "人气榜单", to: "/#ranking" },
  { label: "题材分类", to: "/categories" },
  { label: "新番抢先", to: "/#new" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const isHome = pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const solid = scrolled || !isHome || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-6 max-w-[1400px]">
        <Link to="/" className="flex items-center gap-2 group" aria-label="韩漫YY榜 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span className={`font-heading text-xl md:text-2xl leading-none ${solid ? "text-foreground-950" : "text-background-50"}`}>
            韩漫<span className={solid ? "text-primary-600" : "text-accent-400"}>YY</span>榜
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              className={`relative text-sm font-medium transition-colors hover:after:w-full whitespace-nowrap after:absolute after:-bottom-1 after:left-0 after:h-0.5 after:w-0 after:bg-primary-500 after:transition-all ${
                solid ? "text-foreground-800 hover:text-primary-600" : "text-background-100 hover:text-accent-400"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/categories"
            className="rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            开始选书
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 md:hidden"
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/categories"
              className="mt-1 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              开始选书
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}